module.exports = __webpack_public_path__ + "img/BD-B.86fea1c8.png";